import { useTranslation } from "react-i18next";
import { Button, Col, Row, Typography } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { confirmMessage } from "../../../../pages/page-builder/grapesjs-service";
import TextEditor from "../../../text-editor/TextEditor";
import { convertExpressionToLatexHtml } from "../../../../utils/format";
import { useDirty } from "../../../../contexts/DirtyProvider";

interface QuestionShortTextProps {
  index: number;
  value?: string;
  checked?: any;
  onChange?: (val: { id: number; value: string }) => void;
  onDelete?: (id: number) => void;
}

function QuestionShortTextItem({
  index,
  value,
  onChange = () => {},
  onDelete = () => {},
}: QuestionShortTextProps) {
  const { t } = useTranslation();
  const { Text } = Typography;

  const { setDirty } = useDirty();

  const handleChangeText = (changeValue: string) => {
    onChange({ id: index, value: changeValue });
  };

  const handleDeleteSection = (index: number) => {
    confirmMessage(
      "Xóa lựa chọn",
      0,
      "Bạn có chắc muốn xóa lựa chọn này?",
      () => {
        onDelete(index);
        setDirty(true);
      }
    );
  };

  return (
    <section className="answer">
      <div className="ml-2 form-value w-full">
        <Row>
          <Col span={24} className="form-value__header">
            <Text>Câu trả lời</Text>
          </Col>
          <Col span={24}>
            <TextEditor
              value={value ? convertExpressionToLatexHtml(value) : ""}
              onChange={handleChangeText}
            />
          </Col>
        </Row>
      </div>
      <Button
        className="btn-delete-item ml-2"
        onClick={() => handleDeleteSection(index)}
        icon={<DeleteOutlined />}
      ></Button>
    </section>
  );
}

export default QuestionShortTextItem;
